import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getKnmPreviewOpenApiInfo = (state: IRootState) => state.knmPreview.openApiInfo;
export const getKnmPreviewPassportData = (state: IRootState) => state.knmPreview.passportData;
